import { render, staticRenderFns } from "./AccountantsControlPanelMenu.vue?vue&type=template&id=9dceda3c&"
import script from "./AccountantsControlPanelMenu.vue?vue&type=script&lang=js&"
export * from "./AccountantsControlPanelMenu.vue?vue&type=script&lang=js&"
import style0 from "./AccountantsControlPanelMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports